import React from 'react';
import Header from '../components/Header';
import IndustriesComponent from '../components/Industries';
import Footer from '../components/Footer';

const Industries = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <IndustriesComponent />
      </main>
      <Footer />
    </div>
  );
};

export default Industries;